import api from '@pray/shared/utils/api';

export async function createDonationFund({
  artistId = undefined,
  name = undefined,
  description = undefined,
  imageUrl = undefined,
  defaultAmountMonthly = undefined,
  defaultAmountYearly = undefined,
  amountMonthly2 = undefined,
  amountYearly2 = undefined,
  causeFeedItemEnabled = undefined,
  causeFeedItemPlacement = undefined,
  causeFeedItemMediaUrl = undefined,
  causeFeedItemMediaType = undefined,
  causeFeedItemAudioUrl = undefined,
  causeFeedItemTargetEnabled = undefined,
  causeFeedItemTargetAmount = undefined,
  causeFeedItemStartsAt = undefined,
  causeFeedItemEndsAt = undefined,
  causeFeedItemOverrideEnabled = undefined,
  causeFeedItemTitle = undefined,
  causeFeedItemDescription = undefined,
}) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!name) throw new Error('Fund name is required');
  if (!description) throw new Error('Fund description is required');
  if (!defaultAmountMonthly) throw new Error('Default amount monthly is required');
  if (!defaultAmountYearly) throw new Error('Default amount yearly is required');

  const data = {
    name,
    description,
    default_amount_monthly: defaultAmountMonthly,
    default_amount_yearly: defaultAmountYearly,
  };

  if (imageUrl !== undefined) data.image_url = imageUrl;
  if (amountMonthly2 !== undefined) data.amount_monthly_2 = amountMonthly2;
  if (amountYearly2 !== undefined) data.amount_yearly_2 = amountYearly2;
  if (causeFeedItemEnabled !== undefined) data.cause_feed_item_enabled = causeFeedItemEnabled;
  if (causeFeedItemPlacement !== undefined) data.cause_feed_item_placement = causeFeedItemPlacement;
  if (causeFeedItemMediaUrl) data.cause_feed_item_media_url = causeFeedItemMediaUrl;
  if (causeFeedItemMediaType !== undefined) data.cause_feed_item_media_type = causeFeedItemMediaType;
  if (causeFeedItemAudioUrl) data.cause_feed_item_audio_url = causeFeedItemAudioUrl;
  if (causeFeedItemTargetEnabled !== undefined) data.cause_feed_item_target_enabled = causeFeedItemTargetEnabled;
  if (causeFeedItemTargetAmount !== undefined) data.cause_feed_item_target_amount = causeFeedItemTargetAmount;
  if (causeFeedItemStartsAt !== undefined) data.cause_feed_item_starts_at = causeFeedItemStartsAt;
  if (causeFeedItemEndsAt !== undefined) data.cause_feed_item_ends_at = causeFeedItemEndsAt;
  if (causeFeedItemOverrideEnabled !== undefined) data.cause_feed_item_override_enabled = causeFeedItemOverrideEnabled;
  if (causeFeedItemTitle !== undefined) data.cause_feed_item_title = causeFeedItemTitle;
  if (causeFeedItemDescription !== undefined) data.cause_feed_item_description = causeFeedItemDescription;

  const url = `/web/studio/artists/${artistId}/funds`;
  const response = await api.executePostRequest(url, data);

  return response.data;
}
